import React, { memo } from 'react';
import { useHistory } from 'react-router-dom';
import { Routes } from '@hum/icm-app/src/state';
import { useSession } from '@hum/api/src/Session/useSession';
import { useFlags } from '@hum/icm-app/src/hooks/useFlags';
import TopbarProfileMenu from '@hum/icm-app/src/components/TopbarProfileMenu';
import { TopbarProps } from './Topbar';
import { Icon, Topbar, Text, TextType } from '@hum/ui-library';

// TODO: Re-evalute architecture and DRY during tech debt sprint
export const InvestorTopbar = memo(
  ({
    title,
    fixedBar,
    links,
    background = 'bg-gray-900',
    flow,
  }: TopbarProps) => {
    const history = useHistory();
    const flags = useFlags();
    const session = useSession();

    const isCompany = session.user?.isCompanyAdmin || session.user?.isCompany;
    const isInvestor = session.user?.isFund || session.user?.isFundAdmin;

    const navigationLinks: any[] = [];

    const isInAdminPage = history.location.pathname.includes(Routes.ADMIN);

    const getRootRedirectUrl = () => {
      if (flags.enabled('remove-get-started') && isCompany) {
        return Routes.COMPANY_ACTIVATION_GET_STARTED;
      }

      return Routes.ROOT;
    };

    const rootRedirectUrl = getRootRedirectUrl();

    if (!isInAdminPage && !links) {
      if (isInvestor) {
        navigationLinks.push(
          <a className="navlink-item" href={`${process.env.V2_BASE_URL}/`}>
            <Text type={TextType.BODY_S} className="cursor-pointer" subdued>
              Deals
            </Text>
          </a>
        );
      }
    }

    const logo = (
      <a href={rootRedirectUrl}>
        <Icon.Hum />
      </a>
    );

    return (
      <Topbar
        title={title}
        navigationLinks={navigationLinks}
        userLinks={<TopbarProfileMenu />}
        logo={logo}
        fixedBar={fixedBar}
        background={background}
        flow={flow}
      />
    );
  }
);

InvestorTopbar.displayName = 'InvestorTopbar';
